import React from "react";
import cvsFlavourMapper from "../../../utils/cvsInfo";
import {ReactComponent as Error} from "ui-components-rollup/src/images/monochrome-icons/ic-error.svg";
import styles from "./Error.module.scss";

export default ({ flavour }) => {
    const error = cvsFlavourMapper[flavour].submitError;
    return (
        <div className={styles["container"]}>
            <Error/>
            <span>{error}</span>
        </div>
    );
};
